<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platid" filterable placeholder="筛选所属分组" @on-change="updatePlat">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_id" filterable placeholder="筛选代理" :max-tag-count="3" @on-change="getAppGenList">
                            <Option v-for="(item, index) in getAppList()" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">商户:</span>
                        <Select v-model="table.params.general_id" filterable placeholder="筛选 商户" :max-tag-count="3" @on-change="updateGeneral">
                            <Option v-for="(item, index) in select.general_list" :value="item.general" :label="item.general_name" :key="index">
                                {{ item.general_name }}
                                <span style="color: #bbb">({{ item.general }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="6">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">子商户 :</span>
                        <Select v-model="table.params.pack_no" filterable placeholder="筛选 子商户" clearable>
                            <Option v-for="(item, index) in getPackList()" :value="item.pack_no" :label="item.pack_name" :key="index">
                                {{ item.pack_name }}
                                <span style="color: #bbb">({{ item.pack_no }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">统计时间:</span>
                        <DatePicker type="daterange" v-model="table.params.dataTime" placeholder="统计时间" :options="dateOptions" style="width: 100%"></DatePicker>
                    </label>
                </Col>
                <Col span="6" style="display: flex; justify-content: space-between">
                    <Button type="primary" @click.native="searchData()">查询</Button>
                    <div>
                        <Button type="primary" @click.native="eleToExcel()">导出excel</Button>
                    </div>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" :max-height="760" ref="tableRef"></Table>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
export default {
    name: 'HandicapPromChannelData',
    components: { MulReportHeader },
    data() {
        return {
            loading: false,
            TransTopReqTimer: null,
            timestamp: 0,
            select: {
                general_list: [],
                pack_list: []
            },
            all: {},
            //活动数据
            // GetZhuanPanActiveData
            table: {
                app_name: '',
                gp_name: '',
                params: {
                    general_id: -1,
                    platid: 0,
                    app_id: 0,
                    pack_no: -1,
                    dataTime: [new Date(this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000), this.getCurrentZeroDay()]
                },
                data: [],
                columns: [{ key: 'time', width: 110, align: 'center', renderHeader: (h) => this.renderHeader(h, '日期', '显示对应的时间') }, this.getRenderColumn('zhuan_rate', '新增转化率', '筛选时间内,新增转化率'), this.getRenderColumn('new_user_num', '新增人数', '筛选时间内,子商户新增人数'), this.getRenderColumn('new_user_pay_num', '新增转入人数', '筛选时间内,子商户新增转入人数'), this.getRenderColumn('new_user_pay_total_sum', '新增转入金额', '筛选时间内,子商户新增转入金额'), this.getRenderColumn('new_pay_ave', '人均新增转入金额', '筛选时间内,子商户人均新增转入金额'), this.getRenderColumn('new_ci_ri_pay_rate', '新增次日复充率', '筛选时间内,子商户新增次日复充率'), this.getRenderColumn('new_ci_ri_pay_ave_sum', '人均新增次日复充金额', '筛选时间内,商户或子商户人均新增次日复充金额'), this.getRenderColumn('new_three_pay_rate', '新增3日复充率', '筛选时间内,商户或子商户新增3日复充率'), this.getRenderColumn('new_three_pay_ave_sum', '人均新增3日复充金额', '筛选时间内,商户或子商户人均新增3日复充金额'), this.getRenderColumn('new_seven_pay_rate', '新增7日复充率', '筛选时间内,商户或子商户新增7日复充率'), this.getRenderColumn('new_seven_pay_ave_sum', '人均新增7日复充金额', '筛选时间内,商户或子商户人均新增7日复充金额'), this.getRenderColumn('pay_num', '转入人数', '筛选时间内,商户或子商户转入人数'), this.getRenderColumn('pay_sum', '转入金额', '筛选时间内,商户或子商户转入金额'), this.getRenderColumn('pay_ave', '人均转入金额', '筛选时间内,商户或子商户人均转入金额'), this.getRenderColumn('ci_ri_pay_rate', '次日复充率', '筛选时间内,商户或子商户次日复充率'), this.getRenderColumn('ci_ri_pay_ave_sum', '人均次日复充金额', '筛选时间内,商户或子商户人均次日复充金额'), this.getRenderColumn('three_pay_rate', '3日复充率', '筛选时间内,商户或子商户3日复充率'), this.getRenderColumn('three_pay_ave_sum', '人均3日复充金额', '筛选时间内,商户或子商户人均3日复充金额'), this.getRenderColumn('seven_pay_rate', '7日复充率', '筛选时间内,商户或子商户7日复充率'), this.getRenderColumn('seven_pay_ave_sum', '人均7日复充金额', '筛选时间内,商户或子商户人均7日复充金额'), this.getRenderColumn('pay_put_sum', '充提差', '筛选时间内,商户或子商户充提差'), this.getRenderColumn('fist_pay_num', '首充人数', '筛选时间内,商户或子商户首充人数'), this.getRenderColumn('fist_pay_total_sum', '首充金额', '筛选时间内,商户或子商户首充金额'), this.getRenderColumn('fist_ci_ri_pay_sum', '首充次日复充金额', '筛选时间内,商户或子商户首充次日复充金额'), this.getRenderColumn('fist_ci_ri_pay_rate', '首充次日复充率', '筛选时间内,商户或子商首充次日复充率'), this.getRenderColumn('fist_three_pay_sum', '首充3日复充金额', '筛选时间内,商户或子商户首充3日复充金额'), this.getRenderColumn('fist_three_pay_rate', '首充3日复充率', '筛选时间内,商户或子商户首充3日复充率'), this.getRenderColumn('fist_seven_pay_sum', '首充7日复充金额', '筛选时间内,商户或子商户首充7日复充金额'), this.getRenderColumn('fist_seven_pay_rate', '首充7日复充率', '筛选时间内,商户或子商户首充7日复充率')]
            }
        }
    },
    methods: {
        getRenderColumn(key, title, tip, width = 90) {
            return {
                key,
                width,
                align: 'center',
                resizable: true,
                renderHeader: (h) => this.renderHeader(h, title, tip),
                render: (h, params) => this.renderCol(h, params)
            }
        },
        //查询数据
        searchData() {
            let stime = this.getSecond(this.table.params.dataTime[0])
            let etime = this.getSecond(this.table.params.dataTime[1], false)
            let forStime = new Date(this.table.params.dataTime[0]).getTime() / 1000
            let forEtime = new Date(this.table.params.dataTime[1]).getTime() / 1000
            let dayList = []
            for (let i = forEtime; i >= forStime; ) {
                dayList.push(moment(i * 1000).format('YYYY-MM-DD'))
                i -= 24 * 60 * 60
            }
            let pack_no = this.table.params.pack_no === undefined ? -1 : this.table.params.pack_no
            let app_name = this.app_list.find((el) => el.appid == this.table.params.app_id)['appName']
            let gp_name = pack_no == -1 ? this.select.general_list.find((el) => el.general == this.table.params.general_id)['general_name'] : this.select.pack_list.find((el) => el.pack_no == pack_no)['pack_name']
            this.timestamp = new Date().getTime()
            let params = this.getTransTopParams('GetNewPlatfromData', {
                app_id: this.table.params.app_id,
                platid: this.table.params.platid,
                stime,
                etime,
                page: 1,
                limit: 10000,
                sort: 0,
                general: this.table.params.general_id,
                pack_no,
                timestamp: this.timestamp
            })
            this.table.data = []
            let params1 = this.copyData(params)
            params1.param._func = 'GetNewPlatfromNewPayInfo'
            TransTopReq(params1).then((res1) => {
                let params2 = this.copyData(params)
                params2.param._func = 'GetNewPlatformRepeatPayInfo'
                if (params.timestamp == this.timestamp) {
                    TransTopReq(params2).then((res2) => {
                        let params3 = this.copyData(params)
                        params3.param._func = 'GetNewPlatfromFistPayData'
                        TransTopReq(params3).then((res3) => {
                            TransTopReq(params).then((res) => {
                                let data = res._param.data
                                let data1 = res1._param.data
                                let data2 = res2._param.data
                                let data3 = res3._param.data
                                let dayAve = {
                                    zhuan_rate: 0,
                                    new_user_num: 0,
                                    new_user_pay_num: 0,
                                    new_user_pay_total_sum: 0,
                                    new_pay_ave: 0,
                                    new_ci_ri_pay_rate: 0,
                                    new_ci_ri_pay_ave_sum: 0,
                                    new_three_pay_rate: 0,
                                    new_three_pay_ave_sum: 0,
                                    new_seven_pay_rate: 0,
                                    new_seven_pay_ave_sum: 0,
                                    pay_num: 0,
                                    pay_sum: 0,
                                    pay_ave: 0,
                                    ci_ri_pay_rate: 0,
                                    ci_ri_pay_ave_sum: 0,
                                    three_pay_rate: 0,
                                    three_pay_ave_sum: 0,
                                    seven_pay_rate: 0,
                                    seven_pay_ave_sum: 0,
                                    pay_put_sum: 0,
                                    fist_pay_num: 0,
                                    fist_pay_total_sum: 0,
                                    fist_ci_ri_pay_sum: 0,
                                    fist_ci_ri_pay_rate: 0,
                                    fist_three_pay_sum: 0,
                                    fist_three_pay_rate: 0,
                                    fist_seven_pay_sum: 0,
                                    fist_seven_pay_rate: 0
                                }
                                let filterArray = data1.filter((item) => item.time)
                                let len = filterArray.length
                                let dataResult = filterArray.reduce((result, findData1, index) => {
                                    let item = {}
                                    let time = moment(findData1.time).format('YYYY-MM-DD')
                                    let findData = data.find((el) => moment(el.time).format('YYYY-MM-DD') == time) || {}
                                    let findData2 = data2.find((el2) => moment(el2.time).format('YYYY-MM-DD') == time) || {}
                                    let findData3 = data3.find((el3) => moment(el3.time).format('YYYY-MM-DD') == time) || {}
                                    item.app_name = app_name
                                    item.gp_name = gp_name
                                    item.time = time
                                    item.pay_sum = findData.pay_sum || 0 //转入金额
                                    item.pay_num = findData.pay_user_num || 0 //转入人数
                                    item.pay_put_sum = findData.pay_put_sum || 0 //充提差
                                    item.new_user_num = findData1.new_num || 0 //新增人数
                                    item.new_user_pay_num = findData1.new_user_pay_num || 0 //新增转入人数
                                    item.new_user_pay_total_sum = findData1.new_user_pay_total_sum || 0 //新增转入金额
                                    item.new_ci_ri_pay_rate = findData1.ci_ri_pay_rate || 0 // 新增次日复充率
                                    item.new_three_pay_rate = findData1.three_pay_rate || 0 //新增3日复充率
                                    item.new_seven_pay_rate = findData1.seven_pay_rate //新增7日复充率
                                    item.ci_ri_pay_rate = findData2.ci_ri_pay_rate || 0 // 次日复充率
                                    item.three_pay_rate = findData2.three_pay_rate || 0 //3日复充率
                                    item.seven_pay_rate = findData2.seven_pay_rate //7日复充率
                                    item.pay_ave = this.calcRate(item.pay_sum, item.pay_num) //人均转入金额
                                    item.zhuan_rate = this.calcRate(item.new_user_pay_num, item.new_user_num) //新增转化率
                                    item.new_pay_ave = this.calcRate(findData1.new_user_pay_total_sum, findData1.new_user_pay_num) //人均新增转入金额
                                    item.new_ci_ri_pay_ave_sum = this.calcRate(findData1.ci_ri_pay_sum, findData1.ci_ri_pay_num) //人均新增次日复充金额
                                    item.new_three_pay_ave_sum = this.calcRate(findData1.three_pay_sum, findData1.three_pay_num) //人均新增3日复充金额
                                    item.new_seven_pay_ave_sum = this.calcRate(findData1.seven_pay_sum, findData1.seven_pay_num) //人均新增7日复充金额
                                    item.ci_ri_pay_ave_sum = this.calcRate(findData2.ci_ri_pay_sum, findData2.ci_ri_pay_num) //人均次日复充金额
                                    item.three_pay_ave_sum = this.calcRate(findData2.three_pay_sum, findData2.three_pay_num) //人均3日复充金额
                                    item.seven_pay_ave_sum = this.calcRate(findData2.seven_pay_sum, findData2.seven_pay_num) //人均7日复充金额

                                    item.fist_pay_num = findData3.fist_pay_num || 0 //首充人数
                                    item.fist_pay_total_sum = findData3.fist_pay_total_sum || 0 //首充金额
                                    item.fist_ci_ri_pay_sum = findData3.one_pay_sum || 0 //首充次日复充金额
                                    item.fist_three_pay_sum = findData3.three_pay_sum || 0 //首充3日复充金额
                                    item.fist_seven_pay_sum = findData3.seven_pay_sum || 0 //首充7日复充金额

                                    item.fist_ci_ri_pay_rate = findData3.one_pay_rate || 0 //首充次日复充率
                                    item.fist_three_pay_rate = findData3.three_pay_rate || 0 //首充3日复充率
                                    item.fist_seven_pay_rate = findData3.seven_pay_rate || 0 //首充7日复充率

                                    for (let key in dayAve) {
                                        dayAve[key] += item[key]
                                    }
                                    result.push(item)
                                    return result
                                }, [])
                                if (dataResult.length > 0) {
                                    dayAve.time = '日均'
                                    dayAve.app_id = -10
                                    dayAve.app_name = app_name
                                    dayAve.gp_name = gp_name
                                    //     dayAve.pay_num = res._param.pay_user_num || 0;
                                    //     dayAve.zhuan_rate = dayAve.new_user_num ? dayAve.new_user_pay_num / dayAve.new_user_num : 0; // 新增转化率
                                    //     dayAve.pay_ave = dayAve.pay_num ? dayAve.pay_sum / dayAve.pay_num: 0;//日均人均转入金额
                                    //     dayAve.new_pay_ave = dayAve.new_user_pay_num ? dayAve.new_user_pay_total_sum / dayAve.new_user_pay_num : 0;//日均人均新增转入金额
                                    //     dayAve.new_ci_ri_pay_rate = dayAve.new_user_pay_num ? dayAve.new_ci_ri_pay_num / dayAve.new_user_pay_num : 0; //日均新增次日复充率
                                    //     dayAve.new_three_pay_rate = dayAve.new_user_pay_num ? dayAve.new_three_pay_num / dayAve.new_user_pay_num : 0; //日均新增3日复充率
                                    //     dayAve.new_seven_pay_rate = dayAve.new_user_pay_num ? dayAve.new_seven_pay_num / dayAve.new_user_pay_num  : 0; //日均新增7日复充率
                                    //     dayAve.new_ci_ri_pay_ave_sum = dayAve.new_ci_ri_pay_num ? dayAve.new_ci_ri_pay_sum / dayAve.new_ci_ri_pay_num  : 0; //日均人均新增次日复充金额
                                    //     dayAve.new_three_pay_ave_sum = dayAve.new_three_pay_num ? dayAve.new_three_pay_sum / dayAve.new_three_pay_num  : 0; //日均人均新增3日复充金额
                                    //     dayAve.new_seven_pay_ave_sum = dayAve.new_seven_pay_num ? dayAve.new_seven_pay_sum / dayAve.new_seven_pay_num  : 0; //日均人均新增7日复充金额

                                    //     dayAve.ci_ri_pay_rate = dayAve.pay_num ? dayAve.ci_ri_pay_num / dayAve.pay_num : 0; //日均次日复充率
                                    //     dayAve.three_pay_rate = dayAve.pay_num ? dayAve.three_pay_num / dayAve.pay_num : 0; //日均3日复充率
                                    //     dayAve.seven_pay_rate = dayAve.pay_num ? dayAve.seven_pay_num / dayAve.pay_num : 0; //日均7日复充率
                                    //     dayAve.ci_ri_pay_ave_sum = dayAve.ci_ri_pay_num ? dayAve.ci_ri_pay_sum / dayAve.ci_ri_pay_num : 0; //日均人均次日复充金额
                                    //     dayAve.three_pay_ave_sum = dayAve.three_pay_num ? dayAve.three_pay_sum / dayAve.three_pay_num  : 0; //日均人均3日复充金额
                                    //     dayAve.seven_pay_ave_sum = dayAve.seven_pay_num ? dayAve.seven_pay_sum / dayAve.seven_pay_num: 0; //日均人均7日复充金额

                                    //     dayAve.fist_ci_ri_pay_rate = dayAve.fist_pay_num ? dayAve.fist_ci_ri_pay_num / dayAve.fist_pay_num : 0; //日均次日复充率
                                    //     dayAve.fist_three_pay_rate = dayAve.fist_pay_num ? dayAve.fist_three_pay_num / dayAve.fist_pay_num : 0; //日均3日复充率
                                    //     dayAve.fist_seven_pay_rate = dayAve.fist_pay_num ? dayAve.fist_seven_pay_num / dayAve.fist_pay_num : 0; //日均7日复充率
                                    //     dayAve.fist_ci_ri_pay_ave_sum = dayAve.fist_ci_ri_pay_num ? dayAve.fist_ci_ri_pay_sum / dayAve.fist_ci_ri_pay_num : 0; //日均人均次日复充金额
                                    //     dayAve.fist_three_pay_ave_sum = dayAve.fist_three_pay_num ? dayAve.fist_three_pay_sum / dayAve.fist_three_pay_num : 0; //日均人均3日复充金额
                                    //     dayAve.fist_seven_pay_ave_sum = dayAve.fist_seven_pay_num ? dayAve.sfist_even_pay_sum / dayAve.fist_seven_pay_num : 0; //日均人均7日复充金额

                                    //     dayAve.pay_num = Math.ceil(res._param.pay_user_num / len * 100) / 100; //日均转入人数
                                    //     dayAve.pay_sum = Math.ceil(dayAve.pay_sum / len * 100) / 100; //日均转入金额
                                    //     dayAve.new_user_num = Math.ceil(dayAve.new_user_num / len * 100) / 100; //日均新增人数
                                    //     dayAve.new_user_pay_num = Math.ceil(dayAve.new_user_pay_num / len * 100) / 100; //日均新增转入人数
                                    //     dayAve.new_user_pay_total_sum = Math.ceil(dayAve.new_user_pay_total_sum / len * 100) / 100; //日均新增转入金额
                                    //     dayAve.fist_pay_num = Math.ceil(dayAve.fist_pay_num / len * 100) / 100; //日均首充人数
                                    //     dayAve.fist_user_pay_total_sum = Math.ceil(dayAve.fist_user_pay_total_sum / len * 100) / 100; //日均首充转入金额
                                    //     dayAve.pay_put_sum = Math.ceil(dayAve.pay_put_sum / len * 100) / 100; //日均充提差
                                    //     dayAve.fist_ci_ri_pay_sum =  Math.ceil(dayAve.fist_ci_ri_pay_sum / len * 100) / 100;
                                    //     dayAve.fist_three_pay_sum = Math.ceil(dayAve.fist_three_pay_sum / len * 100) / 100;
                                    //     dayAve.fist_seven_pay_sum = Math.ceil(dayAve.fist_seven_pay_sum / len * 100) / 100;
                                    //     dayAve.fist_pay_total_sum = Math.ceil(dayAve.fist_pay_total_sum / len * 100) / 100;
                                    dataResult.unshift(dayAve)
                                    this.table.data = dataResult
                                }
                            })
                        })
                    })
                }
            })
        },
        renderCol(h, params) {
            let key = params.column.key
            let row = params.row
            let type = key.includes('_rate') ? 1 : key.includes('_sum') || key.includes('pay_ave') ? 2 : 3
            let id = params.row.app_id == -10
            let value = row[key]
            if (params.row.app_id == -10) {
                value = value / this.getTableLength()
            }
            let result = type == 1 ? (value * 100 || 0).toFixed(2) + '%' : type == 2 ? this.getCustomFixed(value / 10000) : this.getCustomFixed(value)
            return h('span', result)
        },
        getTableLength() {
            return Math.max(this.table.data.length - 1, 1)
        },
        getAppList() {
            return this.app_list.filter((el) => this.table.params.platid == el.platform)
        },
        getAppGenList() {
            let params = this.getTransTopParams('GetAppGeneralList', {
                app_id: this.table.params.app_id,
                platid: this.table.params.platid,
                stime: this.getSecond(this.table.params.dataTime[0]),
                etime: this.getSecond(this.table.params.dataTime[1], false),
                page: 1,
                limit: 10000,
                sort: 0,
                general: -1,
                pack_no: -1
            })
            this.select.general_list = []
            this.select.pack_list = []
            this.table.params.general_id = -1
            this.table.params.pack_no = -1
            TransTopReq(params).then((res) => {
                this.select.general_list = res._param.general_list
                this.table.params.general_id = this.select.general_list[0]['general']
                let params1 = this.copyData(params)
                params1.param._func = 'GetPackList'
                TransTopReq(params1).then((res) => {
                    this.select.pack_list = res._param.pack_list || []
                })
            })
        },
        updateGeneral() {
            this.table.params.pack_no = -1
        },
        getPackList() {
            return this.select.pack_list.filter((el) => el.general == this.table.params.general_id)
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                timestamp: param.timestamp,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },
        pageChange() {},
        limitChange() {},
        updatePlat() {
            this.table.params.app_id = this.getAppList()[0]['appid']
            this.getAppGenList()
        },
        initFunc() {
            this.table.params.platid = this.getinitPlatId()
            this.table.params.app_id = this.app_list.find((el) => el.platform == this.table.params.platid)['appid']
            this.getAppGenList()
        }
    },
    created() {
        this.initFunc()
    }
}
</script>

<style scoped lang="less"></style>
